/* eg-lymph-header — the promo countdown.

   The countdown runs an hour per session and is kept in sessionStorage, so a
   reload does not restart it; it rolls over when it runs out. */
(function () {
  'use strict';

  var TOTAL = 60 * 60 * 1000;
  var KEY = 'lfhSaleEnd';

  function pad(n) {
    return (n < 10 ? '0' : '') + n;
  }

  function countdown(root) {
    var el = root.querySelector('[data-lfh-countdown]');
    if (!el) return;

    var end = 0;
    try {
      end = parseInt(sessionStorage.getItem(KEY) || '0', 10);
    } catch (e) {
      /* storage blocked — the in-memory value still counts down */
    }

    function remember(value) {
      try {
        sessionStorage.setItem(KEY, String(value));
      } catch (e) {
        /* noop */
      }
      return value;
    }

    if (!end || end < Date.now()) end = remember(Date.now() + TOTAL);

    function tick() {
      var left = Math.max(0, end - Date.now());
      var s = Math.floor(left / 1000);
      el.textContent =
        pad(Math.floor(s / 3600)) + ':' + pad(Math.floor((s % 3600) / 60)) + ':' + pad(s % 60);
      if (left <= 0) end = remember(Date.now() + TOTAL);
    }

    tick();
    setInterval(tick, 1000);
  }

  function init(root) {
    if (!root || root.dataset.lfhInit === 'true') return;
    root.dataset.lfhInit = 'true';
    countdown(root);
  }

  function boot() {
    var roots = document.querySelectorAll('[data-lfh]');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
